(function () {

  /* ============ 只有这三个常量需要动 ============ */
  var CAL_USER  = "hmpbikes";        // Cal.com 用户名
  var CAL_EVENT = "test-ride";       // 事件 slug
  var FIELD_KEY = "vehicle";         // 下拉题的 Identifier
  /* ============================================ */

  var modal = document.getElementById('hmp-modal');
  var frame = document.getElementById('hmp-frame');
  var title = document.getElementById('hmp-modal-title');
  var sub   = document.getElementById('hmp-modal-sub');
  if (!modal || !frame) return;
  var lastFocus = null;

  function calUrl(vehicle) {
    var u = 'https://app.cal.com/' + CAL_USER + '/' + CAL_EVENT
          + '?embed=hmp&layout=month_view&useSlotsViewOnSmallScreen=true&theme=light';
    if (vehicle) u += '&' + FIELD_KEY + '=' + encodeURIComponent(vehicle);
    return u;
  }

  var skeletonHTML = document.getElementById('hmp-skel').outerHTML;
  var revealTimer = null;

  function reveal() {
    clearTimeout(revealTimer);
    frame.classList.add('ready');
  }

  /* Cal.com 页面加载完会向父窗口发消息，收到再显示 iframe */
  window.addEventListener('message', function (e) {
    var d = e.data;
    if (d && d.originator === 'CAL' &&
        (d.type === 'linkReady' || d.type === '__iframeReady' || d.type === '__dimensionChanged')) {
      reveal();
    }
  });

  function openModal(vehicle, name) {
    lastFocus = document.activeElement;

    title.textContent = name ? 'Test ride the ' + name : 'Book a test ride';
    sub.innerHTML = '415 eBikes &middot; 261 6th St, San Francisco &middot; 30 minutes';

    frame.classList.remove('ready');
    frame.innerHTML = skeletonHTML;

    var f = document.createElement('iframe');
    f.src = calUrl(vehicle);
    f.title = 'Cal.com booking';
    f.addEventListener('load', function () {
      revealTimer = setTimeout(reveal, 700);
    });
    frame.appendChild(f);

    revealTimer = setTimeout(reveal, 6000);

    modal.classList.add('open');
    document.body.classList.add('hmp-locked');
    var x = modal.querySelector('.x');
    if (x) x.focus();
  }

  function closeModal() {
    clearTimeout(revealTimer);
    modal.classList.remove('open');
    document.body.classList.remove('hmp-locked');
    frame.classList.remove('ready');
    frame.innerHTML = skeletonHTML;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.querySelectorAll('[data-vehicle]').forEach(function (b) {
    b.addEventListener('click', function () {
      openModal(b.getAttribute('data-vehicle'), b.getAttribute('data-name'));
    });
  });

  modal.querySelectorAll('[data-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
  });

  /* ---- 免责声明：同样用弹窗打开，内部自带滚动条 ---- */
  var JOTFORM_URL = "https://form.jotform.com/222537478497067";

  function openWaiver() {
    lastFocus = document.activeElement;

    title.textContent = 'Test Drive Waiver';
    sub.innerHTML = 'Optional &middot; you can also sign this when you arrive';

    frame.classList.remove('ready');
    frame.innerHTML = '<div class="plainload">Loading the waiver&hellip;</div>';

    var f = document.createElement('iframe');
    f.src = JOTFORM_URL;
    f.title = 'Test Drive Waiver';
    f.setAttribute('scrolling', 'yes');
    f.setAttribute('allow', 'geolocation; microphone; camera; fullscreen');
    f.addEventListener('load', function () { reveal(); });
    frame.appendChild(f);

    revealTimer = setTimeout(reveal, 6000);

    modal.classList.add('open');
    document.body.classList.add('hmp-locked');
    var x = modal.querySelector('.x');
    if (x) x.focus();
  }

  var wbtn = document.getElementById('hmp-waiver-btn');
  if (wbtn) wbtn.addEventListener('click', openWaiver);

})();
